import styles from "./TogglePadrao.module.css";

type TogglePadraoProps = {
  label: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  className?: string;
  labelDadoBanco?: boolean;
  embutido?: boolean;
};

export function TogglePadrao({
  label,
  checked,
  onChange,
  disabled = false,
  className = "",
  labelDadoBanco = false,
  embutido = false,
}: TogglePadraoProps) {
  return (
    <button
      type="button"
      className={[styles.root, embutido ? styles.rootEmbutido : "", className].filter(Boolean).join(" ")}
      onClick={() => onChange(!checked)}
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
    >
      <span aria-hidden="true" className={`${styles.switch} ${checked ? styles.switchOn : ""}`}>
        <span className={styles.iconGhost} />
        <span className={styles.knob} />
      </span>
      <span className={styles.label} data-i18n-db={labelDadoBanco ? "true" : undefined}>{label}</span>
    </button>
  );
}
